let currentGalleryIndex = 0;
let currentGalleryImages = [];
let preloadedImages = new Map();

// Initialize gallery layout on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  initializeGalleryLayout();
});

function initializeGalleryLayout() {
  if (window.innerWidth < 990) return;
  
  const galleries = document.querySelectorAll('.image-gallery');
  
  galleries.forEach(gallery => {
    const grid = gallery.querySelector('.image-gallery-grid');
    if (!grid) return;
    
    const items = Array.from(grid.querySelectorAll('.gallery-item'));
    if (items.length === 0) return;
    
    processGalleryImages(grid, items);
  });
}

function processGalleryImages(grid, items) {
  const itemsWithAspectRatio = [];
  let loadedCount = 0;
  
  items.forEach((item, index) => {
    const img = item.querySelector('.gallery-item__image');
    if (!img) {
      loadedCount++;
      return;
    }
    
    function processImage() {
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      const isSquareish = Math.abs(aspectRatio - 1) < Math.abs(aspectRatio - (470/689));
      
      // Set square class if image is more square than default ratio
      const wrapper = item.querySelector('.gallery-item__image-wrapper');
      if (isSquareish) {
        wrapper.classList.add('square-image');
      }
      
      itemsWithAspectRatio.push({
        item: item,
        aspectRatio: aspectRatio,
        isSquareish: isSquareish,
        index: index
      });
      
      loadedCount++;
      
      // If all items processed, organize rows
      if (loadedCount === items.length) {
        organizeGalleryRows(grid, itemsWithAspectRatio);
      }
    }
    
    if (img.complete && img.naturalWidth !== 0) {
      processImage();
    } else {
      img.onload = processImage;
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === items.length) {
          organizeGalleryRows(grid, itemsWithAspectRatio);
        }
      };
    }
  });
  
  // Fallback timeout
  setTimeout(() => {
    if (loadedCount < items.length) {
      organizeGalleryRows(grid, itemsWithAspectRatio);
    }
  }, 2000);
}

function organizeGalleryRows(grid, items) {
  // Don't reorder items - just apply styling based on aspect ratios
  // Items remain in their original user-defined order
}

function preloadGalleryImages() {
  currentGalleryImages.forEach(imageData => {
    if (!preloadedImages.has(imageData.url)) {
      const img = new Image();
      img.src = imageData.url;
      preloadedImages.set(imageData.url, img);
    }
  });
}

function updateArrowVisibility(index, prevArrow, nextArrow) {
  if (window.innerWidth <= 749) {
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';
  } else {
    prevArrow.style.display = index === 0 ? 'none' : 'flex';
    nextArrow.style.display = index === currentGalleryImages.length - 1 ? 'none' : 'flex';
  }
}

function openGalleryModal(sectionId, startIndex = 0) {
  const modal = document.getElementById(`gallery-modal-${sectionId}`);
  const thumbnails = modal.querySelectorAll('.gallery-thumbnail');
  
  currentGalleryImages = Array.from(thumbnails).map(thumb => ({
    url: thumb.dataset.imageUrl,
    credits: thumb.dataset.credits
  }));
  
  if (currentGalleryImages.length > 0) {
    currentGalleryIndex = startIndex;
    
    // Move modal to body to ensure highest z-index
    document.body.appendChild(modal);
    
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Preload all images immediately
    preloadGalleryImages();
    
    // Select image and scroll after modal is active
    setTimeout(() => {
      selectGalleryImage(sectionId, startIndex);
    }, 150);
  }
}

function closeGalleryModal(sectionId) {
  const modal = document.getElementById(`gallery-modal-${sectionId}`);
  modal.classList.remove('active');
  document.body.style.overflow = '';
}

function selectGalleryImage(sectionId, index) {
  currentGalleryIndex = index;
  const mainImg = document.getElementById(`gallery-main-img-${sectionId}`);
  const mainCredits = document.getElementById(`gallery-main-credits-${sectionId}`);
  const thumbnails = document.querySelectorAll(`#gallery-modal-${sectionId} .gallery-thumbnail`);
  const prevArrow = document.querySelector(`#gallery-modal-${sectionId} .gallery-nav-prev`);
  const nextArrow = document.querySelector(`#gallery-modal-${sectionId} .gallery-nav-next`);
  const thumbnailContainer = document.querySelector(`#gallery-modal-${sectionId} .gallery-thumbnails`);
  
  if (currentGalleryImages[index]) {
    mainImg.src = currentGalleryImages[index].url;
    mainCredits.textContent = currentGalleryImages[index].credits || '';
    mainCredits.style.display = currentGalleryImages[index].credits ? 'block' : 'none';
    
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === index);
    });
    
    // Show/hide navigation arrows based on current position (but hide all arrows on mobile)
    updateArrowVisibility(index, prevArrow, nextArrow);
    
    // Auto-scroll thumbnails to center active thumbnail
    if (thumbnails[index]) {
      const activeThumbnail = thumbnails[index];
      const containerWidth = thumbnailContainer.offsetWidth;
      const thumbnailWidth = activeThumbnail.offsetWidth;
      const scrollWidth = thumbnailContainer.scrollWidth;
      
      // Check if scrolling is needed
      if (scrollWidth > containerWidth) {
        // Calculate the position of the thumbnail relative to the container
        let thumbnailLeft = activeThumbnail.offsetLeft;
        
        // Account for the ::before pseudo-element that centers thumbnails
        // When thumbnails are centered, we need to scroll to show the active one
        const scrollLeft = thumbnailLeft - (containerWidth / 2) + (thumbnailWidth / 2);
        
        // Clamp scroll position to valid range  
        const maxScroll = scrollWidth - containerWidth;
        const clampedScrollLeft = Math.max(0, Math.min(scrollLeft, maxScroll));
        
        // Use setTimeout to ensure DOM is ready and smooth scrolling works
        setTimeout(() => {
          thumbnailContainer.scrollTo({
            left: clampedScrollLeft,
            behavior: 'smooth'
          });
        }, 100);
      } else {
        // If no scrolling needed, ensure we're at position 0 to show centered thumbnails
        setTimeout(() => {
          thumbnailContainer.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }
}

function navigateGallery(sectionId, direction) {
  const newIndex = currentGalleryIndex + direction;
  
  if (newIndex >= 0 && newIndex < currentGalleryImages.length) {
    selectGalleryImage(sectionId, newIndex);
  }
}

document.addEventListener('keydown', function(e) {
  const activeModal = document.querySelector('.gallery-modal.active');
  if (!activeModal) return;
  
  const sectionId = activeModal.id.replace('gallery-modal-', '');
  
  switch(e.key) {
    case 'Escape':
      closeGalleryModal(sectionId);
      break;
    case 'ArrowLeft':
      navigateGallery(sectionId, -1);
      break;
    case 'ArrowRight':
      navigateGallery(sectionId, 1);
      break;
  }
});

document.addEventListener('click', function(e) {
  const activeModal = document.querySelector('.gallery-modal.active');
  if (!activeModal) return;
  
  const sectionId = activeModal.id.replace('gallery-modal-', '');
  
  if (e.target === activeModal) {
    closeGalleryModal(sectionId);
  }
});


// Touch/swipe functionality for mobile
let touchStartX = 0;
let touchEndX = 0;

document.addEventListener('touchstart', function(e) {
  const activeModal = document.querySelector('.gallery-modal.active');
  if (!activeModal) return;
  
  touchStartX = e.changedTouches[0].screenX;
});

document.addEventListener('touchend', function(e) {
  const activeModal = document.querySelector('.gallery-modal.active');
  if (!activeModal) return;
  
  touchEndX = e.changedTouches[0].screenX;
  const sectionId = activeModal.id.replace('gallery-modal-', '');
  
  // Only trigger swipe if it's a significant horizontal movement
  const swipeThreshold = 50;
  const swipeDistance = Math.abs(touchEndX - touchStartX);
  
  if (swipeDistance > swipeThreshold) {
    if (touchEndX < touchStartX) {
      // Swiped left - next image
      navigateGallery(sectionId, 1);
    } else if (touchEndX > touchStartX) {
      // Swiped right - previous image
      navigateGallery(sectionId, -1);
    }
  }
});

// Handle window resize to update arrow visibility
window.addEventListener('resize', function() {
  const activeModal = document.querySelector('.gallery-modal.active');
  if (!activeModal) return;
  
  const sectionId = activeModal.id.replace('gallery-modal-', '');
  const prevArrow = activeModal.querySelector('.gallery-nav-prev');
  const nextArrow = activeModal.querySelector('.gallery-nav-next');
  
  updateArrowVisibility(currentGalleryIndex, prevArrow, nextArrow);
});